import { WorkCenterDto } from '@app/generated/model';
import { WorkCenterActions, WorkCenterActionTypes } from '@app/core/store/actions/work-center-action';

export const initialState: WorkCenterState = {
  workCenters: [],
  filter: '',
};

export interface WorkCenterState {
  workCenters: WorkCenterDto[];
  filter: string;
}

export function workCenterReducer(state: WorkCenterState = initialState, action: WorkCenterActions): WorkCenterState {
  switch (action.type) {
    case WorkCenterActionTypes.LoadWorkCentersSuccess:
      return {
        ...state,
        workCenters: action.workCenters.map((wc) => ({ ...wc, siteId: wc.siteId })),
      };
    case WorkCenterActionTypes.FilterWorkCenters:
      return {
        ...state,
        filter: action.filter,
      };
    default:
      return state;
  }
}
